export default "__VITE_ASSET__Cv7G9Z8P__"